import { render, staticRenderFns } from "./investor-deal-origination.vue?vue&type=template&id=4a2c1207"
import script from "./investor-deal-origination.vue?vue&type=script&lang=js"
export * from "./investor-deal-origination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports